import { render, staticRenderFns } from "./TrimPdf.vue?vue&type=template&id=a277f3f0&scoped=true&"
import script from "./TrimPdf.vue?vue&type=script&lang=js&"
export * from "./TrimPdf.vue?vue&type=script&lang=js&"
import style0 from "./TrimPdf.vue?vue&type=style&index=0&id=a277f3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a277f3f0",
  null
  
)

export default component.exports